/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { SET_ONEPASS_AND_RECORDING_OR_MY_SHOWS_OPTIONS_GET_ERROR } from './onepassandrecordings/onepassandrecordings.types';
import {
    SET_USER_PREFERENCES_OPTIONS_LIST,
    SET_USER_PREFERENCES_SELECTED_OPTION,
} from './userpreferences.types';

export interface IUserPrefSelectedOption {
    title: string;
    preview: string;
    isDisabled: boolean;
    value?: string;
}

export const setUserPrefOptionsListAction = (
    optionsList: Array<IUserPrefSelectedOption>,
): TivoPayloadAction<{
    optionsList: Array<IUserPrefSelectedOption>;
}> => ({
    type: SET_USER_PREFERENCES_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedUserPrefOption = (
    selectedOption: IUserPrefSelectedOption,
): TivoPayloadAction<{ selectedOption: IUserPrefSelectedOption }> => ({
    type: SET_USER_PREFERENCES_SELECTED_OPTION,
    payload: { selectedOption },
});

export const setOnePassAndRecordingOrMyShowsGetErrorAction = (
    hasOnePassOrMyShowsGetApiError: boolean,
) => ({
    type: SET_ONEPASS_AND_RECORDING_OR_MY_SHOWS_OPTIONS_GET_ERROR,
    payload: {
        hasOnePassOrMyShowsGetApiError,
    },
});
